@if (!loading) {
<div class="box">
  <button mat-button class="back-btn" (click)="back()">
    <mat-icon>arrow_back</mat-icon> Back
  </button>

  <div class="page-header">
    <div>
      <p class="page-title">Users</p>
      <p class="page-desc">Users registered under <strong>{{ applicationName }}</strong> will receive push notifications based on their group subscriptions.</p>
    </div>
    <button mat-flat-button class="add-btn" (click)="openModal(applicationUser, 'New', applicationName, false)">
      <mat-icon>add</mat-icon>
      Add User
    </button>
  </div>

  <div class="stats-row">
    <div class="stat-card">
      <div class="stat-icon stat-icon--total">
        <mat-icon>people</mat-icon>
      </div>
      <div class="stat-info">
        <span class="stat-value">{{ userCount }}</span>
        <span class="stat-label">Users</span>
      </div>
    </div>
  </div>

  <div class="table-toolbar">
    <mat-form-field class="search-field">
      <mat-icon matPrefix>search</mat-icon>
      <input matInput (keyup)="applyFilter($event)" placeholder="Search users…" />
    </mat-form-field>
  </div>

  <div class="table-container">
    <table mat-table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="icon">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <div class="row-icon"><mat-icon>person</mat-icon></div>
        </td>
      </ng-container>

      <ng-container matColumnDef="SK">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
        <td mat-cell *matCellDef="let element">{{ element.email }}</td>
      </ng-container>

      <ng-container matColumnDef="receiveNotifications">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Notifications</th>
        <td mat-cell *matCellDef="let element">
          @if (element.receiveNotifications) {
            <span class="status-badge status-badge--approved">
              <mat-icon>notifications_active</mat-icon> On
            </span>
          } @else {
            <span class="status-badge status-badge--disabled">
              <mat-icon>notifications_off</mat-icon> Off
            </span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button class="action-btn" title="Edit"
                  (click)="openModal(element, 'Edit', applicationName, true); $event.stopPropagation()">
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr *matNoDataRow>
        <td colspan="4">
          <div class="empty-state">
            <mat-icon>person_off</mat-icon>
            <p>No users found</p>
          </div>
        </td>
      </tr>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"
          class="table-row" (click)="openModal(row, 'Edit', applicationName, true)"></tr>
    </table>
  </div>

  <mat-paginator [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons aria-label="Select page">
  </mat-paginator>
</div>
}
@if (loading) {
  <app-loading-spinner></app-loading-spinner>
}
